import { isNilOrEmpty } from "@tastyworks/tastyworks-api"
import { array, object, string } from "yup"

const trustAffiliationOptionValues = [
  "hasTrustForeignInstitutionAffiliation",
  "hasTrustForeignBankAffiliation",
  "isTrusteeCompensated",
] as const

export type TrustAffiliationOptions = Array<
  (typeof trustAffiliationOptionValues)[number]
>

export const trustAffiliationSelectSchema = object({
  hasNoTrustAffiliations: string().oneOf(["true", undefined]),
  affiliations: array()
    .ensure()
    .of(string().oneOf(trustAffiliationOptionValues).required())
    .test(
      "selectsNoneOrSome",
      "yup.common.mixed.required",
      (value, { parent }) => {
        if (parent?.hasNoTrustAffiliations === "true")
          return isNilOrEmpty(value)
        return !isNilOrEmpty(value)
      }
    ),
})

export const trustForeignFinancialInstitutionSchema = object({
  trustForeignInstitution: string().required(),
})

export const trustAffiliationSchema = object({
  trustAffiliationSelect: trustAffiliationSelectSchema,
  trustForeignFinancialInstitution: trustForeignFinancialInstitutionSchema
    .optional()
    .default(undefined),
})
